import { render, staticRenderFns } from "./DetailGoods.vue?vue&type=template&id=7eb1db30&"
import script from "./DetailGoods.vue?vue&type=script&lang=js&"
export * from "./DetailGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports